/// <reference path="../../Administration/Companies/CompaniesDialog.ts" />
namespace SorAraBul.Administration {

    @Serenity.Decorators.registerClass()
    export class CompaniesDetailDialog extends Serenity.EntityDialog<CompaniesRow, any> {
        protected getFormKey() { return CompaniesForm.formKey; }
        protected getIdProperty() { return CompaniesRow.idProperty; }
        protected getLocalTextPrefix() { return CompaniesRow.localTextPrefix; }
        protected getNameProperty() { return CompaniesRow.nameProperty; }
        protected getService() { return CompaniesService.baseUrl; }
        protected getDeletePermission() { return CompaniesRow.deletePermission; }
        protected getInsertPermission() { return CompaniesRow.insertPermission; }
        protected getUpdatePermission() { return CompaniesRow.updatePermission; }

        protected form = new CompaniesForm(this.idPrefix);

        private usersGrid: CompaniesUserGrid;

        constructor() {
            super();
            SorAraBul.Common.preventAutofill([
                this.form.CityId,
                this.form.IlceId
            ]);
        }

        protected updateInterface() {
            super.updateInterface();

            this.deleteButton.hide();
            this.applyChangesButton.hide();
        }

        protected onSaveSuccess(response) {
            this.showSaveSuccessMessage(response);
        }

        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons();

            //if (!Authorization.hasPermission("Administration:SuperAdmin"))
            //    return buttons;

            if (!Authorization.hasPermission("Administration:SuperAdmin"))
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

            return buttons;
        }
    }
}


//namespace SorAraBul.Administration {
//    @Serenity.Decorators.registerClass()
//    @Serenity.Decorators.panel()

//    export class CompaniesDetailDialog extends Serenity.EntityDialog<CompaniesRow, any> {
//        protected getFormKey() { return CompaniesForm.formKey; }
//        protected getIdProperty() { return CompaniesRow.idProperty; }
//        protected getLocalTextPrefix() { return CompaniesRow.localTextPrefix; }
//        protected getNameProperty() { return CompaniesRow.nameProperty; }
//        protected getService() { return CompaniesService.baseUrl; }
//        protected getDeletePermission() { return CompaniesRow.deletePermission; }
//        protected getInsertPermission() { return CompaniesRow.insertPermission; }
//        protected getUpdatePermission() { return CompaniesRow.updatePermission; }

//        protected form = new CompaniesForm(this.idPrefix);

//        private usersGrid: CompaniesUserGrid;

//        constructor() {
//            super();
//        }

//        protected getToolbarButtons() {
//            let buttons = super.getToolbarButtons();
//            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

//            return buttons;
//        }

//        protected updateInterface() {
//            super.updateInterface();

//            this.deleteButton.hide();
//            this.applyChangesButton.hide();
//        }

//        protected onSaveSuccess(response) {
//            this.showSaveSuccessMessage(response);
//        }

//    }
//}
